import {
	bet,
	madnes_add_win,
	madnes_end_round,
	madnes_get_currtime,
	madnes_is_in_autostart,
	madnes_join,
	madnes_money_to_coin,
	madnes_reels_start,
	madnes_reels_stop,
	madnes_win_anim_reset,
	madnes_win_anim_skip,
	win
} from "../framework/src/engine/madnes/madnes";
import {
	big_win,
	forcestopnow,
	fps, he,
	ico_he, mega_win, picture_convert, reels_lenghts,
	reels_pos,
	rotated,
	round_running,
	server_config,
	server_result, set_forcestopnow, set_inanim, set_inwincount,
	set_rotated, states, super_win, wi, behavior_config
} from "../framework/src/engine/madnes/madnes_variables";
import {cylinder_pos, icons, last_symbol, symbols} from "./mv81_config";
import {
	madnes_audio_fade_out, madnes_audio_is_playing,
	madnes_audio_loop,
	madnes_audio_play,
	madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {
	madnes_add_to_render,
	madnes_alpha_to,
	madnes_move_to,
	madnes_rem_from_render, madnes_scale_to
} from "../framework/src/engine/madnes/madnes_render";
import {
	madnes_anim_add,
	madnes_anim_is_playing,
	madnes_anim_play,
	madnes_show_money, madnes_start_coin, madnes_stop_coin
} from "../framework/src/engine/madnes/madnes_anims";
import {mv81_print_reels, result_lock} from "./mv81_core_printer";
import {
	madnes_get_alpha,
	madnes_get_pos_y, madnes_get_texture, madnes_get_visible, madnes_set_alpha, madnes_set_pos,
	madnes_set_pos_y,
	madnes_set_texture
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {STATES} from "../framework/src/states/states";

var anim_speed = 23;
var anim_speed_wild = 22;
var anim_speed_7 = 18;

var rotate_start_time = 0;
var rotate_start_pos = [];
var rotate_start_in_accel = 0;
var rotate_start_swing = 0;
var can_stop = 0;
var rotate_control_start_time = 0;
var rotate_control_swing_end = 0;

var in_free_spins = false;
var in_free_spins_pos = 0;
var in_free_spins_total = 0;

var autospin_rot_lock = false;
var autospin_rot_lock_timer = null;

var autospin_force = false;
var autospin_force_enabled = false;


var autostart;
var force_res;
var mv81_rotate_control_start_sym;

export function mv81_rotate_run()
{
	if(round_running) //waiting for end round
	{
		return;
	}
	else
	{
		mv81_rotate_start();
	}
}

function mv81_rotate_start()
{
	autospin_force_enabled = false;

	if(rotated == 0)
	{
		// madnes_on_round_start();

		clearTimeout(autospin_rot_lock_timer);
		autospin_rot_lock_timer = null;
		if(autospin_rot_lock)
		{
			autospin_rot_lock_timer = setTimeout(mv81_rotate_start, ( 1000 / fps ) * 2 );
			return;
		}

		// madnes_show_stop();

		madnes_win_anim_reset();

		for(var i in server_config.logic.reels)
		{
			while(stopposin[i] > server_config.logic.reels[i].length)
			{
				stopposin[i] = stopposin[i] * 1 - server_config.logic.reels[i].length;
				stopposin_old[i] = stopposin[i];
				reels_pos[i] = stopposin[i] * ico_he;
			}
		}

		if(autostart != "∞" && autostart*1 > 0 && !in_free_spins)
		{
			autostart = autostart * 1 - 1;
		}
		set_rotated(1);
		autospin_rot_lock = true;

		startposin = JSON.parse(JSON.stringify(stopposin));

		if(!in_free_spins)
		{
			// madnes_new_round();
			force_res = "";
		}

		for(var i = 0; i < cylinder_pos.length; i++)
		{
			symbols[i] = 0;
			last_symbol[i] = -1;
			rotate_start_pos[i] = reels_pos[i];
		}

		can_stop = 0;

		rotate_start_time = madnes_get_currtime();

		rotate_control_start_time = 0;
		rotate_start_in_accel = 0;
		rotate_start_swing = 0;
		// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
		set_forcestopnow(0);
		//forcestopnow = 1;
		// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
		scatters_runned = false;

		madnes_audio_play("pre_reels");

		madnes_add_to_render(mv81_rotate_start);
		madnes_reels_start();
	}
	else
	{
		var time = madnes_get_currtime() - rotate_start_time;

		if(
			rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

			time < behavior_config.reel.acceleration.moveBackTime * 1000 &&
			rotate_start_in_accel == 0
		)
		{
			// back
			var time_perc = ( ( 100 / ( behavior_config.reel.acceleration.moveBackTime * 1000 ) ) * time ) / 100;
			for(var i = 0; i < cylinder_pos.length; i++)
			{
				reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
			}
		}
		else if(
			rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

			time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 &&
			rotate_start_in_accel == 0
		)
		{
			// keep
			for(var i = 0; i < cylinder_pos.length; i++)
			{
				reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * 1 );
			}
		}
		else if(
			rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

			//time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveTime * 1000 &&
			time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveBackTime * 1000 &&
			rotate_start_in_accel == 0
		)
		{
			// acc

			var time_perc =
				1 - (
					 (
					 	 (
					 	 	100 / (
					 	 		//behavior_config.reel.acceleration.moveTime * 1000
					 	 		behavior_config.reel.acceleration.moveBackTime * 1000
					 	 	)
					 	 ) * (
					 	 	time - (
					 	 		behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000
					 	 	)
					 	 )
					 ) / 100
				);

			for(var i = 0; i < cylinder_pos.length; i++)
			{
				reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
			}

		}
		else if(
			rotate_start_in_accel == 0
		)
		{
			// rotate accel start or repeat

			madnes_audio_loop("reels");

			for(var i = 0; i < cylinder_pos.length; i++)
			{
				reels_pos[i] = rotate_start_pos[i];
			}

			rotate_start_time = madnes_get_currtime();

			if(++rotate_start_swing >= behavior_config.reel.acceleration.swingCount)
			{

				for(var i = 0; i < cylinder_pos.length; i++)
				{
					if(behavior_config.reel.spin.motionBlur == 1)
					{
						madnes_anim_play("reels_bufer_" + i + "_S0", "blur");
						madnes_anim_play("reels_bufer_" + i + "_S1", "blur");
						madnes_anim_play("reels_bufer_" + i + "_S2", "blur");

						for(var j = 0; j < reels_lenghts[i]; j++)
						{
							madnes_anim_play("reels_bufer_" + i + "_" + j, "blur");
						}

					}
				}

				rotate_start_in_accel = 1;

				mv81_rotate_control_start_sym = Math.round(rotate_start_pos[0] / ico_he);
				rotate_control_start_time = madnes_get_currtime();
			}
		}
		else if(
			rotate_start_in_accel == 1
		)
		{
			// accel start
			var start_speed = behavior_config.reel.acceleration.accelerationHeight / behavior_config.reel.acceleration.moveBackTime;

			if(!isFinite(start_speed) || isNaN(start_speed))
			{
				start_speed = 0;
			}

			var end_speed = behavior_config.reel.spin.commonSpeed;
			if(in_free_spins)
			{
				end_speed = behavior_config.reel.spin.freeSpinSpeed;
			}

			var end_time = behavior_config.reel.spin.timeToReachFullSpeed * 1000;

			var perc = 0;
			var speed = 0;
			var pos = 0;
			var sampling = 10;

			for(var i = 0; i <= time; i = i * 1 + sampling * 1)
			{
				perc = 100 / end_time * i;
				if(!isFinite(perc) || isNaN(perc))
				{
					perc = 0;
				}
				speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
				pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
			}

			for(var i = 0; i < cylinder_pos.length; i++)
			{
				reels_pos[i] = rotate_start_pos[i] + pos * ico_he;
			}

			if(
				!(
					time < behavior_config.reel.spin.timeToReachFullSpeed * 1000
				)
			)
			{
				pos = 0;

				for(var i = 0; i <= ( behavior_config.reel.spin.timeToReachFullSpeed * 1000 ); i = i * 1 + sampling * 1)
				{
					perc = 100 / end_time * i;
					if(!isFinite(perc) || isNaN(perc))
					{
						perc = 0;
					}
					speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
					pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
				}

				rotate_control_swing_end = pos;

				madnes_rem_from_render(mv81_rotate_start);
				madnes_add_to_render(mv81_rotate_control);
			}
		}

		mv81_print_reels();
	}
}

// Kontrola probihajici rotace valcu
var alldone = new Array();

export var stopposin = new Array();
var startposin = new Array();

var stopposin_round = new Array();
var stopping = new Array();

export var stopposin_old = new Array();
var stoppostime_br = new Array();
var stoppostime = new Array();

var stoppos_swing = new Array();

var scatters = 0;
var saloons = 0;
var all_set_for_stop = 0;

var scatters_runned = false;
function mv81_rotate_control()
{
	var time = madnes_get_currtime();

	if(rotated == 1 || all_set_for_stop == 0)
	{
		// Toci se a zatim se neceka ukonceni

		for(var i = 0; i < cylinder_pos.length; i++)
		{
			if(server_result != null && result_lock == 0)
			{
				stopposin[i] = -1;
				stopposin_round[i] = 0;
				stopping[i] = 0;
				stoppostime_br[i] = -1;
				stoppos_swing[i] = 0;
				stoppostime[i] = -1;
				can_stop = 1;
			}

			alldone[i] = 0;

			var cs = behavior_config.reel.spin.commonSpeed;
			if(in_free_spins)
			{
				cs = behavior_config.reel.spin.freeSpinSpeed;
			}

			reels_pos[i] =
				(
					rotate_start_pos[i] +
					(
						(
							(
								(
									time - rotate_control_start_time - (
										behavior_config.reel.spin.timeToReachFullSpeed * 1000
									)
								) / 1000
							) * cs
						) + rotate_control_swing_end
					) * ico_he
				);
			var symbdiff =
					(
						(
							(
								(
									time - rotate_control_start_time - (
										behavior_config.reel.spin.timeToReachFullSpeed * 1000
									)
								) / 1000
							) * cs
						) + rotate_control_swing_end
					);
		}

		scatters = 0;
		saloons = 0;

	}
	else
	{
		// Je na case ukoncit toceni na spravnych pozicich

		for(var i = 0; i < cylinder_pos.length; i++)
		{
			if(stopposin[i] == -1)
			{
				// Nejsou nastaveny pozice pro ukonceni -> nastavuji
				if(forcestopnow === 1)
				{
					var cs = behavior_config.reel.spin.commonSpeed;
					if(in_free_spins)
					{
						cs = behavior_config.reel.spin.freeSpinSpeed;
					}

					var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

					stopposin[i] = Math.round(reels_pos[i] / ico_he) + ( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

					if(i > 0)
					{
						stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i];
					}

				}
				else
				{
					var del = 1;
					if(typeof behavior_config.reel.spin.delayBetweenReelStops != "undefined")
					{
						del = behavior_config.reel.spin.delayBetweenReelStops;
					}
					var cs = behavior_config.reel.spin.commonSpeed;
					if(in_free_spins)
					{
						cs = behavior_config.reel.spin.freeSpinSpeed;
					}

					var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

					stopposin[i] = Math.round(reels_pos[i] / ico_he) + /*(i * del) + */( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

					if(i > 0)
					{
						stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i] + ( i * del );
					}
				}
				/*
				var sc_tmp = 0;
				var sa_tmp = 0;

				var add_tmp_sc = 0;
				var add_tmp_sa = 0;

				for(var j = 0; j < i; j++)
				{
					for(var spos = 0; spos <= 2; spos++)
					{
						if(server_result.result.reelMatrix[0][j][spos] == 8)
						{
							sa_tmp++;
						}
						else if(server_result.result.reelMatrix[0][j][spos] == 9)
						{
							sc_tmp++
						}
					}
					if(sa_tmp >= 2)
					{
						add_tmp_sa++;
					}
					if(sc_tmp >= 2)
					{
						add_tmp_sc++;
					}
				}

				if(sa_tmp >= 2 || sc_tmp >= 2)
				{
					if(typeof behavior_config.reel.spin.scatterDuration != "undefined")
					{
						var add = add_tmp_sc;
						if(add_tmp_sa > add)
						{
							add = add_tmp_sa;
						}
						add = add - 1;
						var tmp_dur = behavior_config.reel.spin.scatterDuration * 1 + behavior_config.reel.spin.scatterDelay * add;
						stopposin[i] += tmp_dur * 1;
					}
					else
					{
						stopposin[i] += 20;
					}
				}
				*/

				while(stopposin[i] <= 0)
				{
					stopposin[i] = ( reels_lenghts[i] * 1 ) - stopposin[i];
				}

				stopposin_old[i] = stopposin[i];
			}

			var cs = behavior_config.reel.spin.commonSpeed;
			if(in_free_spins)
			{
				cs = behavior_config.reel.spin.freeSpinSpeed;
			}
			var end_break_reel_dist = madnes_get_end_dist();

			//var ttrfs = behavior_config.reel.spin.timeToReachFullSpeed;
			var ttrns = behavior_config.reel.spin.timeToReachNullSpeed;

			if(forcestopnow == 1)
			{
				end_break_reel_dist = 0;
				ttrns = 0.01;
			}

			var symbdiff =
					(
						(
							(
								(
									time - rotate_control_start_time - (
										behavior_config.reel.spin.timeToReachFullSpeed * 1000
									)
								) / 1000
							) * cs
						) + rotate_control_swing_end
					);

			if(
				forcestopnow == 0 &&
				(
					(stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= symbdiff &&
					(stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= 0
				)
			)
			{
				reels_pos[i] =
				(
					rotate_start_pos[i] +
					(
						(
							(
								(
									time - rotate_control_start_time - (
										behavior_config.reel.spin.timeToReachFullSpeed * 1000
									)
								) / 1000
							) * cs
						) + rotate_control_swing_end
					) * ico_he
				);

			}
			else if(stoppostime[i] == -1)
			{
				stopping[i] = 1;

				if(stoppostime_br[i] == -1)
				{
					stoppostime_br[i] = time;
				}

				var dif_time = time - stoppostime_br[i];

				var cur_end = 0;

				if(dif_time <= ttrns * 1000)
				{
					dif_time = madnes_get_dist_break(dif_time);

					reels_pos[i] =
						(
							( ( ( stopposin[i] + 0 ) - ( end_break_reel_dist * 1 ) + ( dif_time * 1 ) ) ) * ico_he

						);
				}
				else
				{
					cur_end = 1;
				}

				if(cur_end == 1)
				{
					stoppostime[i] = time;

					if(!in_free_spins)
					{
						//wanted_freespin_hide(i + 1);
					}

					reels_pos[i] =
						(
							( stopposin[i] + 0 ) * ico_he
						);

					if(alldone[i] == 0)
					{
						m81_control_show_spin(i);
						mv81_control_stop_sound(i);

						for(var spos = 0; spos <= 2; spos++)
						{
							madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "stop")
						}

						for(var j = 0; j < reels_lenghts[i]; j++)
						{
							madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");
						}
					}
				}
			}
			else
			{
				var end_time = stoppostime[i];
				var dif_time = time - end_time;

				var bh = behavior_config.reel.brake.brakeHeight;
				var kt = behavior_config.reel.brake.keepTime;
				var mbt = behavior_config.reel.brake.moveBackTime;
				//var mt = behavior_config.reel.brake.moveTime;
				var mt = behavior_config.reel.brake.moveBackTime;


				var cs = behavior_config.reel.spin.commonSpeed;
				if(in_free_spins)
				{
					cs = behavior_config.reel.spin.freeSpinSpeed;
				}

				//cs - rychlost
				//bh - vyska
				mt = bh / cs;

				var swc = behavior_config.reel.brake.swingCount;

				if(dif_time < mt * 1000)
				{
					var add_pos = ( ( (100 / ( mt * 1000 ) ) * dif_time ) / 100 ) * bh;

					reels_pos[i] =
						(
							( stopposin[i] + 0 + add_pos ) * ico_he
						);
				}
				else if(dif_time < mt * 1000 + kt * 1000)
				{
					if(i == reels_lenghts.length - 1)
					{
						madnes_audio_stop("reels");
					}

					reels_pos[i] =
						(
							( stopposin[i] + 0 + bh ) * ico_he
						);
				}
				else if(dif_time < mt * 1000 + kt * 1000 + mbt * 1000)
				{
					if(i == reels_lenghts.length - 1)
					{
						madnes_audio_stop("reels");
					}

					var time2 = dif_time - ( mt * 1000 + kt * 1000 );

					var add_pos = bh - ( ( ( (100 / ( mbt * 1000 ) ) * time2 ) / 100 ) * bh );

					reels_pos[i] =
						(
							( stopposin[i] + 0 + add_pos ) * ico_he
						);

				}
				else
				{
					if(i == reels_lenghts.length - 1)
					{
						madnes_audio_stop("reels");
					}

					reels_pos[i] =
						(
							( stopposin[i] + 0  ) * ico_he
						);

					if(++stoppos_swing[i] < swc)
					{
						stoppostime[i] = time;
					}
					else
					{
						alldone[i] = 1;
					}
				}

			}
		}

		if(alldone.indexOf(0) == -1)
		{
			madnes_audio_stop("reels");

			madnes_rem_from_render(mv81_rotate_control);
			madnes_reels_stop();
			mv81_result_control();
		}

	}

	mv81_print_reels();
}

var madnes_get_end_dist_tmp = -1;
var madnes_get_end_dist_tmp_free = -1;
function madnes_get_end_dist()
{
	if(in_free_spins)
	{
		if(madnes_get_end_dist_tmp_free != -1)
		{
			return madnes_get_end_dist_tmp_free;
		}
	}
	else
	{
		if(madnes_get_end_dist_tmp != -1)
		{
			return madnes_get_end_dist_tmp;
		}
	}

	var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;
	var distance = madnes_get_dist_break(total_time);

	if(in_free_spins)
	{
		madnes_get_end_dist_tmp_free = distance;
	}
	else
	{
		madnes_get_end_dist_tmp = distance;
	}

	return distance;
}

function madnes_get_dist_break(time)
{
	var sampling = 10;

	//var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveTime;
	var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveBackTime;

	if(!isFinite(end_speed) || isNaN(end_speed))
	{
		end_speed = 0;
	}

	var start_speed = behavior_config.reel.spin.commonSpeed;
	if(in_free_spins)
	{
		start_speed = behavior_config.reel.spin.freeSpinSpeed;
	}

	end_speed = start_speed;

	var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;

	var distance = 0;

	for(var i = 0; i <= time; i += sampling)
	{
		var proc = 100 - ( ( 100 / total_time ) * i );
		var speed = ( ( start_speed - end_speed ) * ( proc / 100 ) ) + end_speed;
		distance = ( distance * 1 ) + ( speed * sampling ) ;
	}
	distance = distance / 1000;
	return distance;
}

// Pozadavek na dotoceni valce
var mv81_rotate_stop_loading = 0;
export function mv81_rotate_stop()
{
	if(rotated != 0 && mv81_rotate_stop_loading == 0)
	{
		for(var i = 0; i < cylinder_pos.length; i++)
		{
			stopposin_old[i] = -1;
		}
		all_set_for_stop = 0;
		mv81_rotate_stop_loading = 1;
		var poss = 0;
		for(var i in server_result.result.reelMatrix[0])
		{
			for(var j in server_result.result.reelMatrix[0][i])
			{
				madnes_set_texture("reels_bufer_" + i + "_S" + ( 2 - j ), picture_convert[server_result.result.reelMatrix[0][i][j]] + "_blur");
				madnes_anim_add("reels_bufer_" + i + "_S" + ( 2 - j ), "stop", [1]);
				madnes_anim_add("reels_bufer_" + i + "_S" + ( 2 - j ), "blur", [0]);

				if(picture_convert[server_result.result.reelMatrix[0][i][j]].indexOf("Wild") > 0)
				{
					madnes_anim_add("reels_bufer_" + i + "_S" + ( 2 - j ), "anim", [1, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 1]);
				}

				if(behavior_config.reel.spin.motionBlur == 1)
				{
					madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - j ), "blur");
				}
				else
				{
					madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - j ), "stop");
				}
			}
		}
		setTimeout(function() {
            all_set_for_stop = 1;
            mv81_rotate_stop_loading = 0;
		}, (1000 / ( fps ) ) * poss);
		set_rotated(0);
	}
}

function m81_control_show_spin(reel)
{
	if(reel == 2 && !in_free_spins && !madnes_is_in_autostart())
	{
		states.setState(STATES.FORCESPIN);
		autospin_force_enabled = true;
		// madnes_show_spin();
	}
}

function mv81_control_stop_sound(reel)
{
	//madnes_audio_play("REEL_STOP_"+(reel+1));
	madnes_audio_play("REEL_STOP");

	var up_sym = server_result.result.reelMatrix[0][reel][0];
	var mi_sym = server_result.result.reelMatrix[0][reel][1];
	var dn_sym = server_result.result.reelMatrix[0][reel][2];

	if(up_sym == 8 || mi_sym == 8 || dn_sym == 8)
	{
		madnes_audio_play("wild");

		if(up_sym == 8)
		{
			setTimeout(madnes_anim_play.bind(this, "reels_bufer_" + reel + "_S" + ( 2 - 0 ), "anim"), 100);
		}
		if(mi_sym == 8)
		{
			setTimeout(madnes_anim_play.bind(this, "reels_bufer_" + reel + "_S" + ( 2 - 1 ), "anim"), 100);
		}
		if(dn_sym == 8)
		{
			setTimeout(madnes_anim_play.bind(this, "reels_bufer_" + reel + "_S" + ( 2 - 2 ), "anim"), 100);
		}

	}
}


// Zacatek kontroly vyher
var result_control_pos = 0;
function mv81_result_control()
{
	//madnes_hide_spin();

	set_inanim(1);
	result_control_pos = 0;

	mv81_result_control_part();
}

// kontrola vyhry na aktualni pozici
async function mv81_result_control_part()
{

	if(server_result.result.lineWins == null)
	{
		madnes_win_anim_reset();

		if(madnes_get_alpha("crosses") < 1)
		{
			madnes_alpha_to("crosses", 1, 200);
		}

		mv81_result_win_start_pos = 0;

        mv81_money_add_control();
		autospin_rot_lock = false;
		return;
	}
	if(server_result.result.lineWins[result_control_pos] == null)
	{
		madnes_win_anim_reset();

		if(madnes_get_alpha("crosses") < 1)
		{
			madnes_alpha_to("crosses", 1, 200);
		}

		/*
		for(var i = 0; i < cylinder_pos.length; i++)
		{
			for(var j = 0; j < 3; j++)
			{
				madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
			}
		}
		*/

		if(mv81_result_win_start_pos > 0)
		{
			mv81_result_win_stop();
			return;
		}

		mv81_money_add_control();

		set_inwincount(false);
		autospin_rot_lock = false;
		return;
	}
	else
	{
		// madnes_hide_stop();

		if(result_control_pos == 0 && mv81_result_win_start_pos == 0)
		{
			mv81_result_win_start();
			if(madnes_get_alpha("crosses") > 0)
			{
				madnes_alpha_to("crosses", 0, 200);
			}
		}
		else
		{
			states.setState(STATES.SKIP);

			if(madnes_win_anim_skip())
			{
				var win_set_multip = 1;
				if (server_result.result.lineWins[result_control_pos] && server_result.result.lineWins[result_control_pos].multiplier) {
					win_set_multip = server_result.result.lineWins[result_control_pos].multiplier;
				}

				// win = win * 1 + server_result.result.lineWins[result_control_pos].win * win_set_multip;
				await madnes_add_win(server_result.result.lineWins[result_control_pos].win * win_set_multip);
				result_control_pos++;
				await mv81_result_control_part();
			}
			else
			{
				mv81_result_control_part_proc(server_result.result.lineWins[result_control_pos])
			}
		}
		autospin_rot_lock = false;
		clearTimeout(autospin_rot_lock_timer);
		autospin_rot_lock_timer = null;
	}
}

var mv81_result_win_start_pos = 0;
function mv81_result_win_start()
{
	switch(mv81_result_win_start_pos){
		case 0:
			mv81_result_win_start_pos = 1;
			madnes_move_to("winline_left" ,      20, he / 2 - 28, 100);
			madnes_move_to("winline_right", wi - 20, he / 2 - 28, 100, mv81_result_win_start);
			break;

		case 1:
			mv81_result_win_start_pos = 2;
			madnes_move_to("winline_left" ,     -80, he / 2 - 28, 150);
			madnes_move_to("winline_right", wi + 80, he / 2 - 28, 150);
			//madnes_alpha_to("reels_lights", 1, 500);
			mv81_result_win_lights();
			mv81_result_win_start();
			break;

		case 2:
			mv81_result_control_part();
			break;
	}
}

function mv81_result_win_stop()
{
	switch(mv81_result_win_start_pos){
		case 2:
			mv81_result_win_start_pos = 1;
			madnes_move_to("winline_left" ,      20, he / 2 - 28, 300);
			madnes_move_to("winline_right", wi - 20, he / 2 - 28, 300, mv81_result_win_stop);
			break;

		case 1:
			mv81_result_win_start_pos = 0;
			madnes_move_to("winline_left" ,  0, he / 2 - 28, 200);
			madnes_move_to("winline_right", wi, he / 2 - 28, 200, mv81_result_win_stop);
			//madnes_alpha_to("reels_lights", 0, 500);
			break;

		case 0:
			mv81_result_control_part();
			break;
	}
}

function mv81_result_win_lights()
{
	madnes_alpha_to("reels_lights", 1, 500, mv81_result_win_lights2);
}

function mv81_result_win_lights2()
{
	setTimeout(mv81_result_win_lights3, 500);
}

function mv81_result_win_lights3()
{
	madnes_alpha_to("reels_lights", 0, 500, mv81_result_win_lights4);
}

function mv81_result_win_lights4()
{
	if(mv81_result_win_start_pos > 0 || inbigwin == 1)
	{
		setTimeout(mv81_result_win_lights, 500);
	}
}

// kontrola aktualni vyhry
var audio_name = "";
function mv81_result_control_part_proc(win_set)
{
	// (Caru -> zvuk) -> zabarvit -> otocit -> prostrelit -> otocit zpet -> posunout
	set_inwincount(true);
	var linenum = 0;
	if(win_set.line != null && typeof win_set.line != "undefined")
	{
		linenum = win_set.line + 1;
	}

	if(linenum != 0)
	{
		// madnes_win_anim_add();
		var symbol = picture_convert[win_set.symbol];
		var type = win_set.type;
		var mult = 1;
		if(symbol != "symbol_Seven")
		{
			if(type != "wild")
			{
				audio_name = "WIN_LINE_symb";
			}
			else
			{
				mult = 2;
				audio_name = "WIN_LINE_symb_WILD";
			}
		}
		else
		{
			if(type != "wild")
			{
				audio_name = "WIN_LINE_7";
			}
			else
			{
				mult = 2;
				audio_name = "WIN_LINE_7_wild";
			}
		}

		mult = 3;
		(function(audio_name) {

			setTimeout(function () {
				madnes_audio_play(audio_name);
            }, 100 * mult)

		} (audio_name));

		// setTimeout('madnes_audio_play("' + audio_name + '")', 100 * mult);

		mv81_result_control_part_proc_trn(win_set);
	}
	else
	{
		result_control_pos++;
		mv81_result_control_part();
		// if(in_free_spins)
		// {
		// 	mv81_control_freespins();
		// }
	}
}


var result_tmp; // uchovava docasne vysledek freespinu, je-li to potreba

// kontrola freespinu

// function mv81_control_freespins()
// {
// 	if(server_result.result.freeSpinResults[in_free_spins_pos] == null || typeof server_result.result.freeSpinResults[in_free_spins_pos] == "undefined")
// 	{
// 		if(freepanelpos < 200)
// 		{
// 			freepanelpos = freepanelpos * 1 + 10;
// 			madnes_set_pos_y("table_free-spins", he + freepanelpos);
// 			madnes_set_pos_y("free1", he + freepanelpos);
// 			madnes_set_pos_y("free2", he + freepanelpos);
// 			setTimeout(mv81_control_freespins, 1000 / fps);
// 			return;
// 		}
//
// 		freepanelpos = 200;
//
// 		in_free_spins = false;
// 		in_free_spins_tmp = false;
// 		in_free_spins_pos = 0;
// 		madnes_set_text("free1", in_free_spins_pos.toString());
// 		in_free_spins_total = 0;
// 		madnes_set_text("free2", in_free_spins_total.toString());
//
//
//
// 		madnes_end_round();
//
// 		mv81_money_add_control();
// 	}
// 	else
// 	{
// 		result_lock = 1;
// 		result_tmp = server_result.result.freeSpinResults[in_free_spins_pos].result.reelMatrix;
//
// 		server_result.result.freeSpinNumber = server_result.result.freeSpinResults[in_free_spins_pos].result.freeSpinNumber;
//
// 		setTimeout(mv81_set_result_freespin, 1000);
//
// 		server_result.result.lineWins = server_result.result.freeSpinResults[in_free_spins_pos].result.lineWins;
// 		server_result.result.gameSpecifics = server_result.result.freeSpinResults[in_free_spins_pos].result.gameSpecifics;
//
// 		rotated = 0;
//
//
//
// 		mv81_rotate_start();
// 		in_free_spins_pos++;
// 		madnes_set_text("free1", in_free_spins_pos.toString());
// 	}
// }
//
// // Navrat vysledku na konci freespinu
// function mv81_set_result_freespin()
// {
// 	result_lock = 0;
// 	server_result.result.reelMatrix = result_tmp;
// }

// Otoceni wild symbolu
function mv81_result_control_part_proc_trn(win_set)
{
	// Caru -> zvuk -> zabarvit -> (otocit) -> prostrelit -> otocit zpet -> posunout

	for(var i = 0; i < cylinder_pos.length; i++)
	{
		for(var j = 0; j < 3; j++)
		{
			if(madnes_anim_is_playing("reels_bufer_" + i + "_TMP" +j))
			{
				setTimeout(function() {
					mv81_result_control_part_proc_trn(win_set);
				}, 1000 / fps);
				return;
			}
			if(madnes_get_pos_y("reels_bufer_" + i + "_TMP" + j) > 0)
			{
				madnes_set_pos_y("reels_bufer_" + i + "_S" + j, madnes_get_pos_y("reels_bufer_" + i + "_TMP" + j));
				madnes_set_pos_y("reels_bufer_" + i + "_TMP" + j, -9999);
				madnes_set_pos_y("reels_bufer_" + i + "_TMP2" + j, -9999);
			}
		}
	}

	if(win_set.type == "normal" || win_set.type == "wild")
	{

		madnes_add_win( win_set.win * win_set.multiplier ); //win = win * 1 + ( win_set.win * win_set.multiplier );

		for(let pos in win_set.position)
		{
			var symbol = madnes_get_texture("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ));
			symbol = symbol.replace("_blur", "");

			if(symbol == "symbol_Wild")
			{
				if(
					picture_convert[win_set.symbol] == "symbol_Bell" ||
					picture_convert[win_set.symbol] == "symbol_Dollar" ||
					picture_convert[win_set.symbol] == "symbol_Cherry" ||
					picture_convert[win_set.symbol] == "symbol_Orange" ||
					picture_convert[win_set.symbol] == "symbol_Plum"
				)
				{
					symbol = "symbol_Wild_short";
				}
			}

			madnes_set_texture("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), symbol);

			for(var anim in icons[symbol])
			{
				if(audio_name.indexOf("7") !== -1 && anim == "anim")
				{
					madnes_anim_add("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), "anim_double", madnes_join(icons[symbol][anim], icons[symbol][anim]));
					madnes_anim_add("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), anim, icons[symbol][anim]);
				}
				else
				{
					madnes_anim_add("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), anim, icons[symbol][anim]);
				}
				madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), "stop");
			}

			if(madnes_get_pos_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] )) > 0)
			{
				madnes_set_pos_y(
					"reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ),
					madnes_get_pos_y("reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ))
				);
				madnes_set_pos_y(
					"reels_bufer_" + win_set.position[pos][0] + "_S" + ( 2 - win_set.position[pos][1] ),
					-9999
				);
			}
			var multi = 1;
			if(win_set.type == "wild")
			{
				multi = 1;
				for(let pos2 in win_set.position)
				{
					var symbol = "symbol_X" + win_set.multiplier;

					if(
						picture_convert[win_set.symbol] == "symbol_Bell" ||
						picture_convert[win_set.symbol] == "symbol_Dollar" ||
						picture_convert[win_set.symbol] == "symbol_Cherry" ||
						picture_convert[win_set.symbol] == "symbol_Orange" ||
						picture_convert[win_set.symbol] == "symbol_Plum"
					)
					{
						symbol = symbol + "_long";
					}

					let spriteName = "reels_bufer_" + win_set.position[pos2][0] + "_TMP2" + ( 2 - win_set.position[pos2][1] );

					madnes_set_texture(spriteName, symbol);
					for(var anim in icons[symbol])
					{
						madnes_anim_add(spriteName, anim, icons[symbol][anim]);
					}
					madnes_anim_play(spriteName, "stop");

					madnes_set_pos_y(
						"reels_bufer_" + win_set.position[pos][0] + "_TMP2" + ( 2 - win_set.position[pos][1] ),
						madnes_get_pos_y("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ))
					);

				}
			}

			if(win_set.type == "wild" && audio_name.indexOf("7") === -1)
			{
				(function(pos) {

					var spriteName = "reels_bufer_" + win_set.position[pos][0] + '_TMP' + ( 2 - win_set.position[pos][1]);

					setTimeout(function() {
                        madnes_anim_play(spriteName, "start", anim_speed)
					}, 100 * multi)

				} (pos));

				mv81_result_control_part_proc_trn_back_pos = 0;
			}
			else
			{
				(function(pos)
				{
					setTimeout(function()
					{
                        var spriteName = 'reels_bufer_' + win_set.position[pos][0] + '_TMP' + ( 2 - win_set.position[pos][1] );
                        madnes_anim_play(spriteName, "anim", audio_name.indexOf("7") !== -1 ? anim_speed_7 : anim_speed);

					}, 100 * multi)

				} (pos));

				mv81_result_control_part_proc_trn_back_pos = 0;
			}

		}
		setTimeout(mv81_result_control_part_proc_trn_back.bind(this, win_set), 100 * multi + 1000 / fps);
	}
	else
	{
		mv81_result_control_part_proc_trn_back(win_set);
	}

}

var mv81_result_control_part_proc_trn_back_pos = 0;
function mv81_result_control_part_proc_trn_back(win_set)
{
	if(win_set.type == "wild" && audio_name.indexOf("7") === -1)
	{
		for(var i = 0; i < cylinder_pos.length; i++)
		{
			for(var j = 0; j < 3; j++)
			{
				if(
					madnes_anim_is_playing("reels_bufer_" + i + "_TMP" +j) && madnes_get_visible("reels_bufer_" + i + "_TMP" +j) /* ||
					madnes_anim_is_playing("reels_bufer_" + i + "_TMP2" +j)*/
				)
				{
					setTimeout(mv81_result_control_part_proc_trn_back.bind(this, win_set), 1000 / fps);
					return;
				}
			}
		}

		if(mv81_result_control_part_proc_trn_back_pos == 0)
		{
			mv81_result_control_part_proc_trn_back_pos = 1;
			for(var pos in win_set.position)
			{
				madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), "loop", anim_speed_wild);
			}
			setTimeout(mv81_result_control_part_proc_trn_back.bind(this, win_set), 1000 / fps);
			return;
		}
		else if(mv81_result_control_part_proc_trn_back_pos == 1)
		{
			mv81_result_control_part_proc_trn_back_pos = 2;
			for(var pos in win_set.position)
			{
				madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), "loop", anim_speed_wild);
				madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_TMP2" + ( 2 - win_set.position[pos][1] ), "anim", Math.round(anim_speed_wild * 1.55));
			}
			setTimeout(madnes_audio_play.bind(this, "X" + win_set.multiplier), ( 1000 / fps ) * 2);
			setTimeout(mv81_result_control_part_proc_trn_back.bind(this, win_set), 1000 / fps);
			return;
		}
		else if(mv81_result_control_part_proc_trn_back_pos == 2)
		{
			mv81_result_control_part_proc_trn_back_pos = 3;
			for(var pos in win_set.position)
			{
				madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), "end", anim_speed);
			}
			setTimeout(mv81_result_control_part_proc_trn_back.bind(this, win_set), 1000 / fps);
			return;
		}
		else
		{
			setTimeout(mv81_result_control_part_proc_nxt.bind(this, win_set), 100);
			return;
		}
	}
	else if(win_set.type == "wild" && audio_name.indexOf("7") !== -1)
	{
		if(madnes_audio_is_playing(audio_name))
		{
			setTimeout(mv81_result_control_part_proc_trn_back.bind(this, win_set), 1000 / fps);
			return;
		}

		for(var i = 0; i < cylinder_pos.length; i++)
		{
			for(var j = 0; j < 3; j++)
			{
				if(
					(madnes_anim_is_playing("reels_bufer_" + i + "_TMP" +j) && madnes_get_visible("reels_bufer_" + i + "_TMP" +j)) ||
					(madnes_anim_is_playing("reels_bufer_" + i + "_TMP2" +j) && madnes_get_visible("reels_bufer_" + i + "_TMP2" +j))
				)
				{
					setTimeout(mv81_result_control_part_proc_trn_back.bind(this, win_set), 1000 / fps);
					return;
				}
			}
		}

		if(mv81_result_control_part_proc_trn_back_pos == 0)
		{
			mv81_result_control_part_proc_trn_back_pos = 1;
			for(var pos in win_set.position)
			{
				setTimeout(function(win_set, pos) {
					madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_TMP" + ( 2 - win_set.position[pos][1] ), "anim", 20);
					madnes_anim_play("reels_bufer_" + win_set.position[pos][0] + "_TMP2" + ( 2 - win_set.position[pos][1] ), "anim", 30);
				}.bind(this, win_set, pos), ( 1000 / fps ) * 1)
			}

			setTimeout(madnes_audio_play.bind(this, "X" + win_set.multiplier), ( 1000 / fps ) * 1);

			setTimeout(mv81_result_control_part_proc_trn_back.bind(this, win_set), ( 1000 / fps ) * 10 );
			return;
		}
		else
		{
			setTimeout(mv81_result_control_part_proc_nxt.bind(this, win_set), 100);
			return;
		}
	}
	else
	{
		mv81_result_control_part_proc_nxt(win_set);
	}
}

// Konec animace -> prejit na kontrolu dalsi (pouze nacasovani)
function mv81_result_control_part_proc_nxt(win_set)
{
	for(var i = 0; i < cylinder_pos.length; i++)
	{
		for(var j = 0; j < 3; j++)
		{
			if(madnes_anim_is_playing("reels_bufer_" + i + "_TMP" +j))
			{
				setTimeout(function() {
					mv81_result_control_part_proc_nxt(win_set);
				}, 1000 / fps);
				return;
			}
			if(madnes_get_pos_y("reels_bufer_" + i + "_TMP" + j) > 0)
			{
				madnes_set_pos_y("reels_bufer_" + i + "_S" + j, madnes_get_pos_y("reels_bufer_" + i + "_TMP" + j));
				madnes_set_pos_y("reels_bufer_" + i + "_TMP" + j, -9999);
				madnes_set_pos_y("reels_bufer_" + i + "_TMP2" + j, -9999);
			}
		}
	}

	setTimeout(function() {
		 result_control_pos++;
		 mv81_result_control_part();
	}, 1000 / fps);
}




















var win_anim_played = false;

// Zacatek kontroly pridavani penez
function mv81_money_add_control()
{
	set_inwincount(false);

	madnes_win_anim_reset();
	// madnes_show_stop();

	if(!win_anim_played && win * 1 > 0)
	{
		mv81_money_add_win(madnes_money_to_coin(win));
	}
	else
	{
        setTimeout(madnes_audio_stop.bind(null, 'remittance_A'), 200);

		madnes_end_round();

		// madnes_end_round(true, {}, {}, function () {
        //     madnes_show_btns();
        //     end_result_control();
        // });
	}
}

export function mv81_end_round_recalced()
{
    set_inanim(0);
    win_anim_played = false;

    // madnes_on_end_round_recount(win);
    // madnes_on_round_end();
    // madnes_recount_bet();
	//
    // autospin_force_enabled = false;
    // if(is_in_autostart() || autospin_force)
    // {
    //     autospin_force = false;
    //     madnes_rotate_start();
    //     return;
    // }
}

function is_in_autostart()
{
    return !!autostart;
    //return autostart * 1 > 0 || autostart == "∞";
}

var inbigwin = 0; // Jsme v bigwin modu?
var inmoneyadd = 0; // Prodavaji se aktualne penize
var fromsaloon = 0; // Prichazime ze saloonu? nebude vybuch

function mv81_money_add_win(max)
{
	if(inmoneyadd == 0 && inbigwin == 0 && fromsaloon == 0)
	{
		var tmp_bet = bet;
		if(
			server_result != null &&
			server_result['bet'] != null &&
			server_result['bet'] * 1 > 0

		)
		{
			tmp_bet = server_result['bet']*1;
		}

		if(max * 1 > tmp_bet * 1 * big_win)
		{
			states.setState(STATES.BONUS_WIN);

			mv81_money_add_big_win_pos = 0;
			// madnes_hide_btns();
			mv81_money_add_big_win(max);
			return;
		}

		inmoneyadd = 1;
	}

    win_anim_played = true;

	//madnes_audio_play("WIN_BELL");
	madnes_show_money(max, mv81_money_add_control);

	inmoneyadd = 0;
	inbigwin = 0;
	fromsaloon = 0;

	//setTimeout(mv81_money_add_control, 1000);

}

var mv81_money_add_big_win_pulse_status = 0;
function mv81_money_add_big_win_pulse_start()
{
	mv81_money_add_big_win_pulse_status = 1;
	mv81_money_add_big_win_pulse();
}

function mv81_money_add_big_win_pulse_stop()
{
	mv81_money_add_big_win_pulse_status = 0;
}

function mv81_money_add_big_win_pulse()
{
	if(mv81_money_add_big_win_pulse_status == 1)
	{
		if(madnes_get_alpha("bigwin_sprite") == 0)
		{
			return;
		}
		madnes_scale_to("bigwin_sprite", 1.1, 1.1, 600);
		madnes_scale_to("bigwin", 1.1, 1.1, 600);
		madnes_scale_to("megawin", 1.1, 1.1, 600);
		madnes_scale_to("supermegawin", 1.1, 1.1, 600);
		madnes_scale_to("bigwin_text", 1.1, 1.1, 600, mv81_money_add_big_win_pulse);
		mv81_money_add_big_win_pulse_status = 2;
	}
	else if(mv81_money_add_big_win_pulse_status == 2 || mv81_money_add_big_win_pulse_status == 0)
	{
		if(mv81_money_add_big_win_pulse_status == 2)
		{
			mv81_money_add_big_win_pulse_status = 1;
		}
		madnes_scale_to("bigwin_sprite", 1, 1, 600);
		madnes_scale_to("bigwin", 1, 1, 600);
		madnes_scale_to("megawin", 1, 1, 600);
		madnes_scale_to("supermegawin", 1, 1, 600);
		madnes_scale_to("bigwin_text", 1, 1, 600, mv81_money_add_big_win_pulse);
	}
}

var mv81_money_add_big_win_pos = 0;
function mv81_money_add_big_win(max)
{
	switch(mv81_money_add_big_win_pos){
		case 0:
			madnes_start_coin();
			inbigwin = 1;
			mv81_result_win_lights();
			if(max > bet * super_win)
			{
				madnes_audio_play("SUPER_MEGA_WIN");
			}
			else if(max > bet * mega_win)
			{
				madnes_audio_play("MEGA_WIN");
			}
			else
			{
				madnes_audio_play("BIG_WIN");
			}

			mv81_money_add_big_win_pulse_start();

			madnes_set_pos("bigwin_sprite", wi / 2, he / 2);
			madnes_set_pos("bigwin", wi / 2, he / 2);
			madnes_set_pos("bigwin_text", wi / 2, he / 2);
			madnes_set_text("bigwin_text", 0);

			madnes_set_alpha("bigwin_sprite", 0);
			madnes_set_alpha("bigwin", 0);
			madnes_set_alpha("bigwin_text", 0);

			madnes_alpha_to("bigwin_sprite", 1, 500);
			madnes_alpha_to("bigwin", 1, 500);
			madnes_alpha_to("bigwin_text", 1, 500);

			mv81_money_add_big_win_pos = 1;


			setTimeout(mv81_money_add_big_win.bind(null, max), 250);
			break;
		case 1:
			mv81_money_add_big_win_countadd_sum = 0;
			mv81_money_add_big_win_countadd_sum_max = max;
			mv81_money_add_big_win_countadd_step = 0;
			madnes_add_to_render(mv81_money_add_big_win_countadd);
			break;
		case 2:
			/*if(
				madnes_audio_is_playing("BIG_WIN") ||
				madnes_audio_is_playing("MEGA_WIN") ||
				madnes_audio_is_playing("SUPER_MEGA_WIN")
			)
			{
				setTimeout(mv81_money_add_big_win.bind(this, max), 1000 / fps);
				return;
			}
			else
			{*/
				madnes_stop_coin();
				mv81_money_add_big_win_pos = 3;
				setTimeout(mv81_money_add_big_win.bind(null, max), 2000);
			/*}*/
			break;
		case 3:
			mv81_money_add_big_win_pos = 4;
			setTimeout(mv81_money_add_big_win.bind(null, max), 400);
			break;
		case 4:
			madnes_alpha_to("bigwin_sprite", 0, 1000);
			madnes_alpha_to("bigwin_text", 0, 1000);
			madnes_alpha_to("bigwin", 0, 100);
			madnes_alpha_to("megawin", 0, 1000);
			madnes_alpha_to("supermegawin", 0, 1000);

			mv81_money_add_big_win_pulse_stop();

			mv81_money_add_big_win_pos = 5;
			setTimeout(mv81_money_add_big_win.bind(null, max), 500);
			break;
		case 5:
			madnes_set_pos("bigwin_sprite", -9999, -9999);
			madnes_set_pos("bigwin_text", -9999, -9999);
			madnes_set_pos("bigwin", -9999, -9999);
			madnes_set_pos("megawin", -9999, -9999);
			madnes_set_pos("supermegawin", -9999, -9999);

			madnes_audio_fade_out("BIG_WIN", 1600);
			madnes_audio_fade_out("MEGA_WIN", 1600);
			madnes_audio_fade_out("SUPER_MEGA_WIN", 1600);

			inmoneyadd = 0;
			inbigwin = 0;
			fromsaloon = 0;

            win_anim_played = true;

			mv81_money_add_big_win_add_rempos = 0;

            mv81_money_add_control();
			break;
	}
}

var mv81_money_add_big_win_countadd_sum = 0;
var mv81_money_add_big_win_countadd_sum_max = 0
var mv81_money_add_big_win_countadd_step = 0;
var mv81_money_add_big_win_add_rempos = 0;
function mv81_money_add_big_win_countadd()
{
	var toadd = mv81_money_add_big_win_countadd_sum_max * 1 * ( Math.random() / 160);
	if(toadd < 1)
	{
		toadd = 1;
	}
	mv81_money_add_big_win_countadd_sum = mv81_money_add_big_win_countadd_sum * 1 + toadd * 1;
	mv81_money_add_big_win_countadd_sum = Math.round(mv81_money_add_big_win_countadd_sum);
	if(mv81_money_add_big_win_countadd_sum > mv81_money_add_big_win_countadd_sum_max)
	{
		mv81_money_add_big_win_countadd_sum = mv81_money_add_big_win_countadd_sum_max;
		mv81_money_add_big_win_pos = 2;
		madnes_rem_from_render(mv81_money_add_big_win_countadd);
		setTimeout(mv81_money_add_big_win.bind(null, mv81_money_add_big_win_countadd_sum), 100);
	}

	if(mv81_money_add_big_win_countadd_step == 0)
	{
		if(mv81_money_add_big_win_countadd_sum > bet * mega_win)
		{
			mv81_money_add_big_win_countadd_sum = bet * mega_win;
			mv81_money_add_big_win_countadd_step = 1;
			madnes_alpha_to("bigwin", 0, 1000);
			madnes_set_pos("megawin", wi / 2, he / 2);
			madnes_set_alpha("megawin", 0);
			madnes_alpha_to("megawin", 1, 1000);
		}
	}
	else if(mv81_money_add_big_win_countadd_step == 1)
	{
		mv81_money_add_big_win_countadd_sum = bet * mega_win;
		/*if(madnes_get_alpha("megawin") == 1)
		{*/
			mv81_money_add_big_win_countadd_step = 2;
		/*}*/
	}
	else if(mv81_money_add_big_win_countadd_step == 2)
	{
		if(mv81_money_add_big_win_countadd_sum > bet * super_win)
		{
			mv81_money_add_big_win_countadd_sum = bet * super_win;
			mv81_money_add_big_win_countadd_step = 3;
			madnes_alpha_to("megawin", 0, 1000);
			madnes_set_pos("supermegawin", wi / 2, he / 2);
			madnes_set_alpha("supermegawin", 0);
			madnes_alpha_to("supermegawin", 1, 1000);
		}
	}
	else if(mv81_money_add_big_win_countadd_step == 3)
	{
		mv81_money_add_big_win_countadd_sum = bet * super_win;
		/*if(madnes_get_alpha("supermegawin") == 1)
		{*/
			mv81_money_add_big_win_countadd_step = 4;
		/*}*/
	}

	if(mv81_money_add_big_win_add_rempos++ % 3 == 0)
	{
		madnes_audio_play('remittance_A');
	}

	madnes_set_text("bigwin_text", mv81_money_add_big_win_countadd_sum);
}

// Konec kontroly penez
